
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ebooks/[slug]",
      function () {
        return require("private-next-pages/ebooks/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ebooks/[slug]"])
      });
    }
  